// SelectButton - only border radius override
export const selectbuttonTheme = {
  root: {
    borderRadius: 'var(--bs-border-radius-sm)'
  }
};

// ToggleButton - fix dark mode (surface scale is inverted, need explicit gray colors)
export const togglebuttonTheme = {
  root: {
    borderRadius: 'var(--bs-border-radius-sm)'
  },
  colorScheme: {
    light: {
      // Aura defaults work fine in light mode
    },
    dark: {
      root: {
        // Normal state
        background: '{gray.800}',
        borderColor: '{gray.700}',
        color: '{gray.300}',
        // Hover state
        hoverBackground: '{gray.700}',
        hoverColor: '{gray.200}',
        // Checked state
        checkedBackground: '{gray.950}',
        checkedBorderColor: '{gray.600}',
        checkedColor: '{gray.100}'
      },
      icon: {
        color: '{gray.400}',
        hoverColor: '{gray.300}',
        checkedColor: '{gray.200}'
      },
      content: {
        checkedBackground: '{gray.950}',
        checkedShadow: 'none'
      }
    }
  }
};
